(function menoplayCartDrawerModule(window, document) {
  "use strict";

  var SELECTORS = {
    root: "[data-menoplay-cart-root]",
    content: ".menoplay-cart-drawer__content",
    status: "[data-menoplay-cart-status]",
    error: "[data-menoplay-cart-error]",
    item: "[data-menoplay-cart-item]",
    quantity: "[data-menoplay-quantity]",
    modalityOpen: "[data-menoplay-modality-open]",
    modalityToggle: "[data-menoplay-modality-toggle]",
    upgrade: "[data-menoplay-upgrade]",
    subscriptionSwitch: "[data-menoplay-subscription-switch]",
    remove: "[data-menoplay-remove]",
    cedula: "[data-menoplay-cedula]",
    cedulaError: "[data-menoplay-cedula-error]",
    terms: "[data-menoplay-terms]",
    checkoutForm: "[data-menoplay-checkout-form]",
    checkout: "[data-menoplay-checkout]",
    checkoutLabel: "[data-menoplay-checkout-label]",
    nextCharge: "[data-menoplay-next-charge]",
  };

  function getCartUrl(path) {
    var cartUrl =
      (window.theme && window.theme.routes && window.theme.routes.cart) ||
      "/cart";
    return cartUrl + path;
  }

  function getCheckoutUrl() {
    var rootUrl =
      (window.theme && window.theme.routes && window.theme.routes.root_url) ||
      "/";
    return rootUrl.replace(/\/?$/, "/") + "checkout";
  }

  function getSectionId(root) {
    var section = root && root.closest("[data-section-id]");
    return (section && section.getAttribute("data-section-id")) || "cart";
  }

  function getSectionRenderUrl(sectionId) {
    var url = new URL(window.location.href);
    url.searchParams.set("section_id", sectionId || "cart");
    return url.pathname + url.search;
  }

  function nextCalendarDate() {
    var today = new Date();
    var targetMonth = today.getMonth() + 1;
    var lastTargetDay = new Date(
      today.getFullYear(),
      targetMonth + 1,
      0,
    ).getDate();
    var next = new Date(
      today.getFullYear(),
      targetMonth,
      Math.min(today.getDate(), lastTargetDay),
    );
    return new Intl.DateTimeFormat("es-CO", {
      day: "numeric",
      month: "long",
      year: "numeric",
    }).format(next);
  }

  function MenoPlayCartDrawer(root) {
    this.root = root;
    this.sectionId = getSectionId(root);
    this.cedula = "";
    this.cedulaSaved = false;
    this.cedulaSaveTimer = null;
    this.isSavingCedula = false;
    this.cedulaSavePromise = null;
    this.isCheckoutPreparing = false;
    this.termsAccepted = false;
    this.lastTrigger = null;
    this.isUpdating = false;
    this.isRefreshing = false;
    this.refreshQueued = false;
    this.existingOneTimeHandoffPromise = null;
    this.refreshPromise = null;
    this.bind();
    this.updateDrawerOffset();
    this.updateDynamicCopy();
  }

  MenoPlayCartDrawer.prototype.bind = function bind() {
    var self = this;

    this.root.addEventListener("change", function onChange(event) {
      if (event.target.matches(SELECTORS.quantity)) {
        self.closeModalitySelector(event.target);
        self.updateQuantity(event.target.value);
      }

      if (event.target.matches(SELECTORS.terms)) {
        self.termsAccepted = event.target.checked;
        self.updateCheckoutState();
      }
    });

    this.root.addEventListener("input", function onInput(event) {
      var fiscal;
      var documentValue;
      var digitCount;
      if (!event.target.matches(SELECTORS.cedula)) return;
      documentValue = event.target.value.replace(/[^0-9-]/g, "");
      if (documentValue.indexOf("-") !== -1) documentValue = documentValue.slice(0, documentValue.indexOf("-") + 1) + documentValue.slice(documentValue.indexOf("-") + 1).replace(/-/g, "");
      self.cedula = documentValue;
      event.target.value = self.cedula;
      self.cedulaSaved = false;
      self.clearCedulaError();
      fiscal = window.EusariFiscalColombia;
      digitCount = self.cedula.replace(/\D/g, "").length;
      if (fiscal && fiscal.validateFiscalDocument && digitCount >= 7 && !fiscal.validateFiscalDocument(self.cedula)) self.showCedulaError("Ingresa un NIT o Cédula válido para Colombia.");
      self.updateCheckoutState();
      self.scheduleCedulaSave();
    });

    this.root.addEventListener("click", function onClick(event) {
      if (event.target.closest("[data-drawer-underlay]")) {
        window.dispatchEvent(
          new CustomEvent("theme:scroll:unlock", { bubbles: true }),
        );
        return;
      }

      var closeTrigger = event.target.closest(
        '[data-drawer-toggle="drawer-cart"]',
      );
      var modalityOpen = event.target.closest(SELECTORS.modalityOpen);
      var action = event.target.closest(
        SELECTORS.upgrade +
          ", " +
          SELECTORS.subscriptionSwitch +
          ", " +
          SELECTORS.remove,
      );
      if (closeTrigger) {
        event.preventDefault();
        self.closeDrawer();
        return;
      }
      if (modalityOpen) {
        event.preventDefault();
        self.toggleModalitySelector(modalityOpen);
        return;
      }
      if (!action) return;
      event.preventDefault();
      self.lastTrigger = action;
      if (action.matches(SELECTORS.upgrade)) self.updateQuantity(3);
      if (action.matches(SELECTORS.subscriptionSwitch))
        self.updateQuantity(1, action.getAttribute("data-selling-plan-id"));
      if (action.matches(SELECTORS.remove)) self.updateQuantity(0);
    });

    this.root.addEventListener("focusout", function onFocusOut(event) {
      var fiscal = window.EusariFiscalColombia;
      var checkoutTarget = event.relatedTarget && event.relatedTarget.closest && event.relatedTarget.closest(SELECTORS.checkout);
      if (checkoutTarget || !event.target.matches(SELECTORS.cedula) || !fiscal || !fiscal.validateFiscalDocument || !fiscal.validateFiscalDocument(self.cedula)) return;
      self.clearCedulaSaveTimer();
      if (!self.cedulaSaved) self.saveCedula().then(function onSaved() { self.updateCheckoutState(); }).catch(function onInvalid() { self.updateCheckoutState(); });
    });

    this.root.addEventListener("submit", function onSubmit(event) {
      if (!event.target.matches(SELECTORS.checkoutForm)) return;
      event.preventDefault();
      self.checkout();
    });

    this.root.addEventListener("theme:drawer:open", function onOpen(event) {
      document.dispatchEvent(
        new CustomEvent("menoplay:pdp:close-overlays", {
          detail: { except: "cart" },
        }),
      );
      if (window.theme && window.theme.state) window.theme.state.cartOpen = true;
      self.updateDrawerOffset();
      if (event.detail && event.detail.menoplayRefreshed) return;
      self.refresh();
    });

    this.root.addEventListener("theme:drawer:close", function onClose() {
      if (window.theme && window.theme.state) window.theme.state.cartOpen = false;
    });

    window.addEventListener("resize", function onResize() {
      self.updateDrawerOffset();
    });

    document.addEventListener(
      "menoplay:cart:existing-one-time-package",
      function onExistingOneTimePackage() {
        self.openExistingOneTimePackage();
      },
    );

    document.addEventListener("theme:cart:change", function onCartChange() {
      if (!self.isUpdating) self.refresh();
    });

    document.addEventListener("theme:cart:reload", function onCartReload() {
      if (!self.isUpdating) self.refresh();
    });

    document.addEventListener("theme:cart:popdown", function onCartPopdown(event) {
      if (event.detail && event.detail.menoplayRefreshed) {
        self.root.dispatchEvent(
          new CustomEvent("theme:drawer:open", {
            bubbles: false,
            detail: { menoplayRefreshed: true },
          }),
        );
        return;
      }
      if (
        self.isUpdating ||
        !document.querySelector('[data-menoplay-pdp-module="hero"]')
      ) {
        return;
      }
      self.refresh().then(function onRefreshed(refreshed) {
        if (!refreshed) return;
        self.root.dispatchEvent(
          new CustomEvent("theme:drawer:open", {
            bubbles: false,
            detail: { menoplayRefreshed: true },
          }),
        );
      });
    });

    document.addEventListener("menoplay:pdp:close-overlays", function onOverlayClose(event) {
      if (event.detail && event.detail.except === "cart") return;
      if (self.root.classList.contains("drawer--visible")) self.closeDrawer();
    });

    document.addEventListener("click", function onPageAnchor(event) {
      var link = event.target.closest("a[href^='#']");
      if (!link || link.closest(SELECTORS.root)) return;
      if (self.root.classList.contains("drawer--visible")) self.closeDrawer();
    });

    [
      "cart:item-added",
      "cart:updated",
      "cartUpdated",
      "cart:changed",
    ].forEach(function listenToLegacyCartEvent(eventName) {
      document.addEventListener(eventName, function onLegacyCartEvent() {
        if (!self.isUpdating) self.refresh();
      });
    });
  };

  MenoPlayCartDrawer.prototype.find = function find(selector) {
    return this.root.querySelector(selector);
  };

  MenoPlayCartDrawer.prototype.openExistingOneTimePackage =
    function openExistingOneTimePackage() {
      var self = this;
      if (this.existingOneTimeHandoffPromise) return this.existingOneTimeHandoffPromise;

      this.existingOneTimeHandoffPromise = this.refresh().then(function revealAfterRefresh(refreshed) {
        if (!refreshed) return false;
        document.dispatchEvent(
          new CustomEvent("theme:cart:popdown", {
            detail: { menoplayRefreshed: true },
            bubbles: true,
          }),
        );
        window.setTimeout(function revealSelector() {
          var toggle = self.find(SELECTORS.modalityToggle);
          var trigger = self.find(SELECTORS.modalityOpen);
          if (!toggle || !trigger) return;
          toggle.open = true;
          trigger.setAttribute("aria-expanded", "true");
          self.announce("Ya tienes un paquete MenoPlay en el carrito. Cambia su modalidad aquí.");
          if (document.activeElement === document.body && trigger.focus) {
            trigger.focus({ preventScroll: true });
          }
        }, 0);
        return true;
      }).finally(function clearHandoff() {
        self.existingOneTimeHandoffPromise = null;
      });

      return this.existingOneTimeHandoffPromise;
    };

  MenoPlayCartDrawer.prototype.toggleModalitySelector =
    function toggleModalitySelector(trigger) {
      var toggle = this.find(SELECTORS.modalityToggle);
      if (!toggle) return;
      toggle.open = !toggle.open;
      trigger.setAttribute("aria-expanded", String(toggle.open));
      if (toggle.open) {
        var selectedQuantity = toggle.querySelector(SELECTORS.quantity + ":checked");
        if (selectedQuantity) selectedQuantity.focus();
      }
    };

  MenoPlayCartDrawer.prototype.closeModalitySelector =
    function closeModalitySelector(input) {
      var toggle = input.closest(SELECTORS.modalityToggle);
      var trigger = this.find(SELECTORS.modalityOpen);
      if (!toggle) return;
      toggle.open = false;
      if (trigger) trigger.setAttribute("aria-expanded", "false");
    };

  MenoPlayCartDrawer.prototype.updateDrawerOffset =
    function updateDrawerOffset() {
      this.root.style.setProperty("--menoplay-drawer-top", "0px");
    };

  MenoPlayCartDrawer.prototype.closeDrawer = function closeDrawer() {
    this.root.classList.remove("drawer--visible", "is-open");
    if (window.theme && window.theme.state) window.theme.state.cartOpen = false;
    window.dispatchEvent(
      new CustomEvent("theme:scroll:unlock", { bubbles: true }),
    );
    window.setTimeout(
      function hideClosedDrawer() {
        if (!this.root.classList.contains("drawer--visible")) {
          this.root.classList.add("display-none");
        }
      }.bind(this),
      800,
    );
  };

  MenoPlayCartDrawer.prototype.announce = function announce(message) {
    var status = this.find(SELECTORS.status);
    if (status) status.textContent = message;
  };

  MenoPlayCartDrawer.prototype.showError = function showError(message) {
    var error = this.find(SELECTORS.error);
    if (!error) return;
    error.textContent = message;
    error.hidden = false;
    this.announce(message);
  };

  MenoPlayCartDrawer.prototype.clearError = function clearError() {
    var error = this.find(SELECTORS.error);
    if (!error) return;
    error.textContent = "";
    error.hidden = true;
  };

  MenoPlayCartDrawer.prototype.showCedulaError = function showCedulaError(
    message,
  ) {
    var input = this.find(SELECTORS.cedula);
    var error = this.find(SELECTORS.cedulaError);
    if (input) input.setAttribute("aria-invalid", "true");
    if (error) error.textContent = message;
    this.announce(message);
  };

  MenoPlayCartDrawer.prototype.focusCedulaError = function focusCedulaError() {
    var input = this.find(SELECTORS.cedula);
    if (!input) return;
    input.classList.remove("menoplay-cart-drawer__cedula--shake");
    void input.offsetWidth;
    input.classList.add("menoplay-cart-drawer__cedula--shake");
    input.focus();
  };

  MenoPlayCartDrawer.prototype.clearCedulaError = function clearCedulaError() {
    var input = this.find(SELECTORS.cedula);
    var error = this.find(SELECTORS.cedulaError);
    if (input) {
      input.removeAttribute("aria-invalid");
      input.classList.remove("menoplay-cart-drawer__cedula--shake");
    }
    if (error) error.textContent = "";
  };

  MenoPlayCartDrawer.prototype.clearCedulaSaveTimer = function clearCedulaSaveTimer() {
    if (this.cedulaSaveTimer) window.clearTimeout(this.cedulaSaveTimer);
    this.cedulaSaveTimer = null;
  };

  MenoPlayCartDrawer.prototype.scheduleCedulaSave = function scheduleCedulaSave() {
    var fiscal = window.EusariFiscalColombia;
    var self = this;
    var documentValue;
    if (this.isSavingCedula) return;
    this.clearCedulaSaveTimer();
    if (!fiscal || !fiscal.normalizeDocument || !fiscal.validateFiscalDocument) return;
    documentValue = fiscal.normalizeDocument(this.cedula);
    if (!fiscal.validateFiscalDocument(documentValue)) return;
    this.cedulaSaveTimer = window.setTimeout(function saveValidCedula() {
      self.cedulaSaveTimer = null;
      if (self.cedula !== documentValue || self.cedulaSaved) return;
      self.saveCedula().then(function onSaved() { self.updateCheckoutState(); }).catch(function onInvalid() { self.updateCheckoutState(); });
    }, 600);
  };

  MenoPlayCartDrawer.prototype.isSubscription = function isSubscription() {
    return Boolean(this.find(SELECTORS.terms));
  };

  MenoPlayCartDrawer.prototype.requiresCedula = function requiresCedula() {
    return this.root.getAttribute("data-country-code") === "CO" && Boolean(this.find(SELECTORS.cedula));
  };

  MenoPlayCartDrawer.prototype.updateCheckoutState =
    function updateCheckoutState() {
      var checkout = this.find(SELECTORS.checkout);
      if (!checkout) return;
      checkout.disabled =
        (this.isSubscription() && !this.termsAccepted) ||
        this.isUpdating || this.isSavingCedula || this.isCheckoutPreparing;
    };

  MenoPlayCartDrawer.prototype.updateDynamicCopy =
    function updateDynamicCopy() {
      var nextCharge = this.find(SELECTORS.nextCharge);
      var input = this.find(SELECTORS.cedula);
      var terms = this.find(SELECTORS.terms);
      if (nextCharge) nextCharge.textContent = nextCalendarDate();
      if (input) input.value = this.cedula;
      if (terms) terms.checked = this.termsAccepted;
      this.updateCheckoutState();
    };

  MenoPlayCartDrawer.prototype.refresh = async function refresh() {
    var self = this;
    if (this.isRefreshing) {
      this.refreshQueued = true;
      return this.refreshPromise || Promise.resolve(false);
    }
    this.isRefreshing = true;

    this.refreshPromise = (async function refreshUntilSettled() {
      var refreshed = false;

      do {
        self.refreshQueued = false;
        refreshed = await self.renderFreshContent();
      } while (self.refreshQueued);

      return refreshed;
    })();

    try {
      return await this.refreshPromise;
    } finally {
      this.isRefreshing = false;
      this.refreshPromise = null;
    }
  };

  MenoPlayCartDrawer.prototype.renderFreshContent = async function renderFreshContent() {
    var response;
    var markup;
    var parsed;
    var freshContent;
    var currentContent;
    var freshScrollable;

    try {
      response = await fetch(getSectionRenderUrl(this.sectionId), {
        credentials: "same-origin",
      });
      if (!response.ok) throw new Error("No pudimos actualizar tu carrito.");
      markup = await response.text();
      parsed = new DOMParser().parseFromString(markup, "text/html");
      freshContent = parsed.querySelector(SELECTORS.content);
      currentContent = this.find(SELECTORS.content);
      if (!freshContent || !currentContent)
        throw new Error("No pudimos actualizar tu carrito.");
      freshScrollable = freshContent.querySelector("[data-drawer-scrolls]");
      if (this.root.classList.contains("drawer--visible") && freshScrollable) {
        freshScrollable.setAttribute("data-scroll-lock-scrollable", "");
      }
      currentContent.replaceWith(freshContent);
      this.updateDynamicCopy();
      return true;
    } catch (error) {
      this.showError(
        error.message ||
          "No pudimos actualizar tu carrito. Intenta nuevamente.",
      );
      return false;
    }
  };

  MenoPlayCartDrawer.prototype.updateQuantity = async function updateQuantity(
    quantity,
    sellingPlanId,
  ) {
    var item = this.find(SELECTORS.item);
    var key = item && item.getAttribute("data-cart-key");
    var variantId = item && item.getAttribute("data-variant-id");
    var response;
    var cart;
    var replacement;
    var replacementAdded = false;
    var targetQuantity = Number(quantity);
    var replacementQuantity = sellingPlanId ? 1 : targetQuantity;
    var rollbackQuantity = 0;
    var sendReplacementAdd;
    var currentSellingPlanId = item && item.getAttribute("data-selling-plan-id");
    var isOneTimeQuantityChange = targetQuantity > 0 && !sellingPlanId && !currentSellingPlanId;

    if (!key || this.isUpdating) return;
    this.isUpdating = true;
    this.root.classList.add("is-updating");
    this.clearError();
    this.updateCheckoutState();
    this.announce(
      quantity === 0
        ? "Eliminando producto..."
        : "Actualizando tu modalidad...",
    );

    try {
      if (
        targetQuantity > 0 &&
        window.MenoPlayCartLimit
      ) {
        if (window.MenoPlayCartLimit.registerVariantIds && variantId) {
          window.MenoPlayCartLimit.registerVariantIds(variantId);
        }
        if (isOneTimeQuantityChange) {
          if (!window.MenoPlayCartLimit.replaceOneTimePackageQuantity)
            throw new Error(
              "No pudimos actualizar tu carrito. Intenta nuevamente.",
            );
          cart = await window.MenoPlayCartLimit.replaceOneTimePackageQuantity(
            key,
            variantId,
            targetQuantity,
          );
        } else {
          sendReplacementAdd = await window.MenoPlayCartLimit.beginReplacement(
            key,
            variantId,
          );
        }
      }
      if (targetQuantity === 0) {
        response = await fetch(getCartUrl("/change.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 }),
        });
        if (!response.ok)
          throw new Error(
            "No pudimos actualizar tu carrito. Intenta nuevamente.",
          );
        cart = await response.json();
      } else if (!isOneTimeQuantityChange) {
        if (!variantId)
          throw new Error(
            "No pudimos actualizar tu carrito. Intenta nuevamente.",
          );

        var addBody = new URLSearchParams();
        addBody.set("id", variantId);
        addBody.set("quantity", String(replacementQuantity));

        if (sellingPlanId) {
          addBody.set("selling_plan", sellingPlanId);
        }

        response = await (sendReplacementAdd || fetch)(getCartUrl("/add.js"), {
          method: "POST",
          credentials: "same-origin",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: addBody.toString(),
        });
        if (!response.ok)
          throw new Error(
            "No pudimos actualizar tu carrito. Intenta nuevamente.",
        );
        replacement = await response.json();
        replacementAdded = true;
        if (replacement && replacement.key === key) {
          rollbackQuantity = Math.max(0, Number(replacement.quantity) - replacementQuantity);
          response = await fetch(getCartUrl("/change.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: replacement.key, quantity: replacementQuantity }),
          });
          if (!response.ok)
            throw new Error(
              "No pudimos actualizar tu carrito. Intenta nuevamente.",
            );
          replacementAdded = false;
          cart = await response.json();
        } else {
          response = await fetch(getCartUrl("/change.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: key, quantity: 0 }),
          });
          if (!response.ok) {
            if (replacement && replacement.key) {
              replacementAdded = false;
              await fetch(getCartUrl("/change.js"), {
                method: "POST",
                credentials: "same-origin",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ id: replacement.key, quantity: 0 }),
              });
            }
            throw new Error(
              "No pudimos actualizar tu carrito. Intenta nuevamente.",
            );
          }
          replacementAdded = false;
          cart = await response.json();
        }
      }
      document.dispatchEvent(
        new CustomEvent("theme:cart:change", {
          detail: { cart: cart },
          bubbles: true,
        }),
      );
      await this.refresh();
      this.announce(
        quantity === 0 ? "Producto eliminado." : "Modalidad actualizada.",
      );
    } catch (error) {
      if (replacementAdded && replacement && replacement.key) {
        try {
          await fetch(getCartUrl("/change.js"), {
            method: "POST",
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ id: replacement.key, quantity: rollbackQuantity }),
          });
        } catch (rollbackError) {
          console.error("No pudimos revertir el cambio de modalidad.", rollbackError);
        }
      }
      this.showError(
        error.message ||
          "No pudimos actualizar tu carrito. Intenta nuevamente.",
      );
    } finally {
      this.isUpdating = false;
      this.root.classList.remove("is-updating");
      this.updateCheckoutState();
    }
  };

  MenoPlayCartDrawer.prototype.saveCedulaTask = async function saveCedulaTask() {
    var fiscal = window.EusariFiscalColombia;
    var item = this.find(SELECTORS.item);
    var label = this.find(SELECTORS.checkoutLabel);
    var wasLoading = this.root.classList.contains("is-loading");
    var record;
    var documentValue;
    var productContext;
    var payload;

    if (
      !fiscal ||
      typeof fiscal.normalizeDocument !== "function" ||
      typeof fiscal.validateFiscalDocument !== "function" ||
      typeof fiscal.createFiscalRecord !== "function" ||
      typeof fiscal.syncCartNote !== "function" ||
      typeof fiscal.buildWebhookPayload !== "function" ||
      typeof fiscal.sendFiscalWebhook !== "function"
    ) {
      throw new Error(
        "No pudimos preparar la información fiscal. Intenta nuevamente.",
      );
    }
    this.clearCedulaSaveTimer();
    documentValue = fiscal.normalizeDocument(this.cedula);
    this.cedula = documentValue;
    var input = this.find(SELECTORS.cedula);
    if (input) input.value = documentValue;
    if (!fiscal.validateFiscalDocument(documentValue)) {
      this.showCedulaError("Ingresa un NIT o Cédula válido para Colombia.");
      throw new Error("Cédula inválida.");
    }

    this.isSavingCedula = true;
    this.root.classList.add("is-loading");
    this.updateCheckoutState();
    if (label) label.textContent = "Validando...";
    this.announce("Validando...");
    try {
      record = fiscal.createFiscalRecord(documentValue);
      productContext = {
        variant_id: item && item.getAttribute("data-variant-id"),
        product_id: item && item.getAttribute("data-product-id"),
        line_item_key: item && item.getAttribute("data-cart-key"),
        pack_quantity: this.find(SELECTORS.quantity + ":checked")?.value || 1,
      };
      await fiscal.syncCartNote(record, productContext);
      if (item && productContext.line_item_key) {
        item.setAttribute("data-cart-key", productContext.line_item_key);
      }
      payload = fiscal.buildWebhookPayload(record, productContext);
      fiscal.sendFiscalWebhook(payload).catch(function onWebhookFailure(error) {
        console.error(
          "[MenoPlayCartDrawer] Fiscal webhook failed without blocking checkout preparation.",
          error,
        );
      });
      this.cedulaSaved = this.cedula === documentValue;
      if (this.cedulaSaved) this.clearCedulaError();
    } finally {
      this.isSavingCedula = false;
      if (this.cedula !== documentValue && !this.isCheckoutPreparing) this.scheduleCedulaSave();
      this.updateCheckoutState();
      if (!wasLoading) {
        this.root.classList.remove("is-loading");
        if (label) label.textContent = "Ir al pago";
      }
    }
  };

  MenoPlayCartDrawer.prototype.saveCedula = function saveCedula() {
    var self = this;
    if (this.cedulaSavePromise) return this.cedulaSavePromise;
    this.cedulaSavePromise = this.saveCedulaTask().finally(function clearSavePromise() {
      self.cedulaSavePromise = null;
    });
    return this.cedulaSavePromise;
  };

  MenoPlayCartDrawer.prototype.checkout = async function checkout() {
    var checkout = this.find(SELECTORS.checkout);
    var label = this.find(SELECTORS.checkoutLabel);
    var input;
    var fiscal;
    var documentValue;

    if (!checkout || this.isUpdating || this.isCheckoutPreparing) return;
    if (this.isSubscription() && !this.termsAccepted) {
      this.showError("Acepta los términos de la suscripción para continuar.");
      return;
    }
    if (this.requiresCedula()) {
      input = this.find(SELECTORS.cedula);
      fiscal = window.EusariFiscalColombia;
      documentValue = fiscal && fiscal.normalizeDocument
        ? fiscal.normalizeDocument(input ? input.value : this.cedula)
        : this.cedula;
      if (this.cedula !== documentValue) this.cedulaSaved = false;
      this.cedula = documentValue;
      if (input) input.value = documentValue;
      if (!fiscal || !fiscal.validateFiscalDocument || !fiscal.validateFiscalDocument(documentValue)) {
        this.showCedulaError("Ingresa un NIT o Cédula válido para Colombia.");
        this.focusCedulaError();
        return;
      }
    }

    this.isCheckoutPreparing = true;
    this.isUpdating = true;
    this.root.classList.add("is-loading");
    checkout.disabled = true;
    if (label) label.textContent = "Preparando tu pago…";
    this.announce("Preparando tu pago…");
    this.updateCheckoutState();

    try {
      if (this.requiresCedula() && !this.cedulaSaved) await this.saveCedula();
      if (this.requiresCedula()) {
        input = this.find(SELECTORS.cedula);
        documentValue = fiscal.normalizeDocument(input ? input.value : this.cedula);
        if (!fiscal.validateFiscalDocument(documentValue) || !this.cedulaSaved || this.cedula !== documentValue) {
          this.showCedulaError("El número cambió mientras lo validábamos. Revísalo e intenta nuevamente.");
          this.focusCedulaError();
          return;
        }
      }
      window.location.assign(getCheckoutUrl());
    } catch (error) {
      if (error.message !== "Cédula inválida.")
        this.showError(error.message || "No pudimos preparar el pago. Intenta nuevamente.");
    } finally {
      this.isCheckoutPreparing = false;
      this.isUpdating = false;
      this.root.classList.remove("is-loading");
      if (label) label.textContent = "Ir al pago";
      this.updateCheckoutState();
    }
  };

  function init() {
    document.querySelectorAll(SELECTORS.root).forEach(function mount(root) {
      if (root.dataset.menoplayCartDrawerBound === "true") return;
      root.dataset.menoplayCartDrawerBound = "true";
      new MenoPlayCartDrawer(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})(window, document);
